/** @format */
import React, { useState } from 'react'
import { _$, Select, Option, Tooltip, Icon, Collapse, CollapseItem } from '@king-design/react'
import styled from 'styled-components'
import AlarmingCollapseItem from './AlarmingCollapseItem'
import ApiCommon from 'src/api/ApiCommon'
import Api from 'src/api/ApiAlarming'
import { useParams } from 'react-router-dom'
import { get } from 'lodash'
import variable from 'src/static/styles/var'
import { request } from 'src/utils'
import { useAsync } from 'react-use'
import dayjs from 'dayjs'
import useTableGroup from 'src/hooks/useTableGroup'
const MonitorAlarmingCard: React.FC<{ className?: string }> = ({ className }) => {
  const params = useParams()
  const productType = get(params, 'productType')
  const [currentProduct, setCurrentProduct] = useState<any>('')
  const regionGroup = useTableGroup('monitorRegionList')
  // 项目list
  const { value: projectList } = useAsync(async () => {
    const result = await request(ApiCommon.getAccountAllProjectList, {
      headers: {
        'X-KSC-SERVICE': 'iam'
      }
    })
    return result?.data?.ListProjectResult?.ProjectList || []
  })

  // 项目list
  const { value: alarmingList } = useAsync(async () => {
    const result = await request(Api.getAlarming, {
      data: {
        StartTime: dayjs().subtract(30, 'day').unix(),
        EndTime: dayjs().unix()
      }
    })
    if (result?.data?.alertingList?.length) {
      const initProduct = result?.data?.alertingList[0]?.ProductType + ''
      if (productType !== undefined) {
        const find = result?.data?.alertingList.find(item => {
          return item.ProductType === parseInt(productType)
        })
        collapseChange(find?.ProductType !== undefined ? find?.ProductType + '' : '')
      } else {
        collapseChange(initProduct)
      }
      return result?.data?.alertingList || []
    } else {
      setCurrentProduct('')
      return []
    }
  })

  // 切换卡片
  const collapseChange = value => {
    if (value !== undefined) {
      setTimeout(() => {
        const anchorElement = document.getElementById(value)
        if (anchorElement) {
          const top = anchorElement.offsetTop - 58
          window.scrollTo({ top })
        }
      }, 300)
      setCurrentProduct(value)
    }
  }

  return (
    <div className={className}>
      <div className="filter">
        <Select value={currentProduct} onChangeValue={val => collapseChange(val)} filterable>
          {alarmingList?.length
            ? alarmingList.map(({ ProductType, ProductName }) => (
                <Option key={ProductType} value={ProductType + ''}>
                  {ProductName}
                </Option>
              ))
            : null}
        </Select>
        <Tooltip content={_$('近30天未恢复的告警')}>
          <Icon style={{ fontSize: '14px', marginLeft: '8px' }} className="icon ion-help-circled" />
        </Tooltip>
      </div>
      <Collapse
        value={[currentProduct]}
        onChangeValue={value => {
          setCurrentProduct(value[0])
        }}
        accordion
        arrow="left"
      >
        {alarmingList?.length && projectList?.length
          ? alarmingList.map(({ ProductType, ProductName, ResourceSet }) => (
              <CollapseItem
                id={ProductType}
                key={ProductType}
                value={ProductType + ''}
                slotTitle={
                  <div className="collapse-item-title">
                    <span className="product-name">{ProductName}</span>
                    <span>{_$('共{x}个资源告警数', { x: ResourceSet?.length })}</span>
                  </div>
                }
              >
                <AlarmingCollapseItem
                  visible={currentProduct === ProductType + ''}
                  resources={ResourceSet}
                  regionGroup={regionGroup}
                  productType={ProductType}
                  productName={ProductName}
                  projectList={projectList}
                />
              </CollapseItem>
            ))
          : null}
      </Collapse>
    </div>
  )
}
export default styled(MonitorAlarmingCard)`
  .filter {
    display: flex;
    & > * {
      /* margin-right: 5px; */
      margin-bottom: 0;
      line-height: 30px;
    }
  }
  .k-collapse {
    margin-top: 16px;
    padding: 0;
    .k-collapse-item {
      &.k-active {
        & > .k-collapse-title {
          .k-collapse-arrow {
            color: #0091ea;
          }
          .collapse-item-title {
            span {
              color: #0091ea;
            }
            .product-name {
              font-size: 16px;
              font-weight: 500;
            }
          }
        }
        .k-collapse-wrapper {
          border: none;
          .alram-item .k-card-header {
            margin-top: 0;
          }
        }
      }
      & > .k-collapse-title {
        height: 48px;
        line-height: 48px;
        background: #fff;
        padding: 0 16px;
        display: flex;
        justify-content: space-between;
        .collapse-item-title {
          span {
            color: #999;
            font-size: 12px;
            font-weight: 400;
            margin-right: 8px;
          }
        }
      }
      .k-collapse-wrapper {
        padding: 0 16px 16px;
        border-top: 1px solid #e5e5e5;
        .alram-box {
          box-shadow: none;
          .header {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            .k-icon {
              cursor: pointer;
              margin-left: 8px;
            }
          }
        }
      }
      .k-table {
        p {
          margin-bottom: 0;
        }
        .table-host-name {
          display: flex;
          align-items: center;
          .copy-icon {
            font-size: 14px;
            margin-left: 5px;
            opacity: 0;
            transition: opacity 0.15s ease-out;
          }
        }
        .table-rule-item {
          display: block;
          cursor: pointer;
          &:hover {
            color: ${variable.primaryColor};
          }
          span {
            margin-right: 4px;
          }
        }
      }
    }
  }
`
